import { Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { AudienceTarget, AudienceTargets } from "types/headsetReleaseTypes";
import { targetName, targetOrgCount } from "./releaseFormat";

interface TargetCellProps {
  target: AudienceTarget;
  targets: AudienceTargets;
}

export function TargetCell({ target, targets }: TargetCellProps) {
  const { t } = useTranslation();
  return (
    <div>
      <Text fw={600} size="sm">
        {targetName(target, targets)}
      </Text>
      <Text size="xs" c="dimmed">
        {t(`headsetReleases.target.${target.kind}`)}
        {target.kind !== "org" &&
          ` · ${t("headsetReleases.orgCount", { count: targetOrgCount(target, targets) ?? 0 })}`}
      </Text>
    </div>
  );
}
